import React from 'react';

import { useUserMatchScoresState, useUserMatchScoresActions } from './UserMatchScoresContext';
import { getUserMatchScores } from './restApi';
import PageController from '../../Shared/UI/PageController/components/PageController';

const UserMatchScoresPageController = () => {
  const state = useUserMatchScoresState();
  const { onResponse, onError } = useUserMatchScoresActions();

  const fetchPage = (pageNumber) => {
    getUserMatchScores({
      userId: state?.userId,
      pageNumber,
      sortBy: state?.sortBy,
      sortDirection: state?.sortDirection,
      gapFilter: state?.gapFilter,
      onResponse,
      onError,
    });
  };

  return (
    <PageController
      pageNumber={state?.pageNumber}
      numberOfPages={state?.numberOfPages}
      goToFirstPage={() => fetchPage(1)}
      goToPreviousPage={() => fetchPage(state?.pageNumber - 1)}
      goToNextPage={() => fetchPage(state?.pageNumber + 1)}
      goToLastPage={() => fetchPage(state?.numberOfPages)}
    />
  );
};

export default UserMatchScoresPageController;
